export const AdminLogin='AdminUserLogin'
export const AdminUserDetails='AdminUserDetails'
export const AdminUserUpdate = 'AdminUserUpdate'
export const CourseDetails = 'CourseDetails'
export const CourseList = 'CourseList'
export const StateList = 'StateList'
export const CountryList = 'CountryList'
export const DrivingRangeCreate = 'DrivingRangeCreate'
export const DrivingRangeDetails = 'DrivingRangeDetails'
export const DrivingRangeUpdate = 'DrivingRangeUpdate'
export const DrivingRangeList = 'DrivingRangeList'
export const DrivingRangeGPSCreate='DrivingRangeGPSCreate'
export const DrivingRangeGPSDetails='DrivingRangeGPSDetails'
export const DrivingRangeGPSUpdate='DrivingRangeGPSUpdate'
export const CourseElevationDataDetails='CourseElevationDataDetails'
// New HeatMap (Three.js terrain editor) endpoints
export const CourseElevationStepDataDetails='CourseElevationStepDataDetails'      // 1m: body {id_course, step:1}
export const CourseElevationDataThreeMeterDetails='CourseElevationDataThreeMeterDetails' // 3m: body {id_course}
export const CourseGPSElementsDetails='CourseGPSElementsDetails'                  // elements: body {id_course} -> vectorGPSObject
export const CourseElevationDataCreate='CourseElevationDataCreate'                // upload: {id_courseInt, step, operation}
export const CourseGPSVectorDetails='CourseGPSVectorDetails'
export const CourseGPSVectorMapDetails='CourseGPSVectorMapDetails'
export const CourseGPSNameList='CourseGPSNameList'
export const CourseMappingGPSDetails='CourseMappingGPSDetails'
export const CourseGPSVectorMapUpdate='CourseGPSVectorMapUpdate'
export const CourseMappingGPSUpdate='CourseMappingGPSUpdate'
export const CourseGPSVectorMapRemove = 'CourseGPSVectorMapRemove'
export const  CourseGPSVectorMapCreate='CourseGPSVectorMapCreate'
export const  CourseSyncOutputCreate='CourseSyncOutputCreate'
export const VectorOutputCreate='VectorOutputCreate'
export const CourseMappingScorecardDetails='CourseMappingScorecardDetails'
export const MappingTaskNoteList='MappingTaskNoteList'
export const MappingTaskNoteCreate='MappingTaskNoteCreate'
export const CourseMappingLayoutUpdate='CourseMappingLayoutUpdate'
export const CourseGPSVectorMapShiftUpdate='CourseGPSVectorMapShiftUpdate'
export const CourseLayoutList = 'CourseLayoutList'
export const CourseCreate = 'CourseCreate'
export const CourseGPSMapUpdate = 'CourseGPSMapUpdate'
export const CourseUpdate = 'CourseUpdate'
export const CourseCopyCreate = 'CourseCopyCreate'
export const LanguageList = 'LanguageList'
export const CourseTeeColorList = 'CourseTeeColorList'
export const CourseTeeTypeList = 'CourseTeeTypeList'
export const CourseTeeTypeCreate = 'CourseTeeTypeCreate'
export const CourseMappingScorecardUpdate = 'CourseMappingScorecardUpdate'

export const CourseMappingScorecardImageUpload = 'CourseMappingScorecardImageUpload'
export const CourseMappingScorecardImageDelete = 'CourseMappingScorecardImageDelete'

export const CourseRenderingCreate = 'CourseRenderingCreate'
export const CourseRenderingDetails = 'CourseRenderingDetails'
export const CourseRenderingUpdate = 'CourseRenderingUpdate'
export const CourseRenderingOptionList = 'CourseRenderingOptionList'


